import React from "react"
import Button from "@motorata/base-ui.components.atoms.button"
import styled, { css } from "styled-components"
import { P, Title } from "@motorata/base-ui.components.atoms.typography";
import { blockStyles } from "@motorata/base-ui.components.atoms._atoms";

export const NewsletterInput = ({ type = "primary" }) => {
  return (
    <InputWrapper type={type}>
      <input placeholder="Podaj swój email" />
      <Button icon="send" height="40px">
        Zapisz
      </Button>
    </InputWrapper>
  )
}

const NewsletterSection = () => {
  return (
    <Wrapper>
      <Content>
        <Title margin="0 0 1rem" color="white" elementType="label" center>
          Zapisz się do naszego newslettera
        </Title>
        <P small color="white" margin="0 auto 2rem" maxWidth="900px" textAlign="center">
          Aby być na bieżąco z nowymi ofertami oraz informacjami z świata motoryzacji, zapisz się do
          naszego newslettera.
        </P>
        <NewsletterInput />
      </Content>
    </Wrapper>
  )
}

export default NewsletterSection

const InputWrapper = styled.div`
  max-width: 500px;
  margin: 0 auto;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
  background: white;

  input {
    width: 100%;
    border: 0;
    padding: 13px 15px;
    font-size: ${({ theme }) => theme.font.L};
    font-weight: ${({ theme }) => theme.font.light};
    color: ${({ theme }) => theme.color.second};
  }

  button {
    position: absolute;
    right: 5px;
    top: 5px;
  }

  @media (max-width: 600px) {
    button {
      position: relative;
      margin: 5px;
      margin-top: 0px;
      left: 0;
      top: 0;
      width: calc(100% - 10px);
    }
  }

  ${({ type }) =>
    type === "secondary" &&
    css`
      input {
        font-size: ${({ theme }) => theme.font.L};
      }
    `}
`

const Content = styled.div`
  padding: ${({ theme }) => theme.space.XL};
  background: ${({ theme }) => theme.color.primary};
  border-radius: 10px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;

  &::before {
    display: block;
    position: absolute;
    width: 30vw;
    height: 30vw;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.02);
    content: "";
    left: 0;
    top: 0;
    z-index: 0;
  }

  &::after {
    display: block;
    position: absolute;
    width: 30vw;
    height: 30vw;
    border-radius: 50%;
    transform: translate(50%, 50%);
    background: rgba(0, 0, 0, 0.02);
    content: "";
    right: 0;
    bottom: 0;
    z-index: 0;
  }

  > * {
    position: relative;
    z-index: 1;
  }

  @media (max-width: 800px) {
    padding: ${({ theme }) => theme.space.L};
  }
`

const Wrapper = styled.div`
  ${blockStyles};
`
